import { AnvilSelectOptionsProps } from '@servicetitan/design-system';

export const countryWithStates = [
  {
    countryCode: 'US',
    name: 'United States',
    regions: [
      {
        code: 'AL',
        name: 'Alabama',
      },
      {
        code: 'AK',
        name: 'Alaska',
      },
      {
        code: 'AS',
        name: 'American Samoa',
      },
      {
        code: 'AZ',
        name: 'Arizona',
      },
      {
        code: 'AR',
        name: 'Arkansas',
      },
      {
        code: 'CA',
        name: 'California',
      },
      {
        code: 'CO',
        name: 'Colorado',
      },
      {
        code: 'CT',
        name: 'Connecticut',
      },
      {
        code: 'DE',
        name: 'Delaware',
      },
      {
        code: 'DC',
        name: 'D.C.',
      },
      {
        code: 'FL',
        name: 'Florida',
      },
      {
        code: 'FM',
        name: 'Federated States of Micronesia',
      },
      {
        code: 'GA',
        name: 'Georgia',
      },
      {
        code: 'GU',
        name: 'Guam',
      },
      {
        code: 'HI',
        name: 'Hawaii',
      },
      {
        code: 'ID',
        name: 'Idaho',
      },
      {
        code: 'IL',
        name: 'Illinois',
      },
      {
        code: 'IN',
        name: 'Indiana',
      },
      {
        code: 'IA',
        name: 'Iowa',
      },
      {
        code: 'KS',
        name: 'Kansas',
      },
      {
        code: 'KY',
        name: 'Kentucky',
      },
      {
        code: 'LA',
        name: 'Louisiana',
      },
      {
        code: 'ME',
        name: 'Maine',
      },
      {
        code: 'MH',
        name: 'Marshall Islands',
      },
      {
        code: 'MD',
        name: 'Maryland',
      },
      {
        code: 'MA',
        name: 'Massachusetts',
      },
      {
        code: 'MI',
        name: 'Michigan',
      },
      {
        code: 'MN',
        name: 'Minnesota',
      },
      {
        code: 'MS',
        name: 'Mississippi',
      },
      {
        code: 'MO',
        name: 'Missouri',
      },
      {
        code: 'MT',
        name: 'Montana',
      },
      {
        code: 'NE',
        name: 'Nebraska',
      },
      {
        code: 'NV',
        name: 'Nevada',
      },
      {
        code: 'NH',
        name: 'New Hampshire',
      },
      {
        code: 'NJ',
        name: 'New Jersey',
      },
      {
        code: 'NM',
        name: 'New Mexico',
      },
      {
        code: 'NY',
        name: 'New York',
      },
      {
        code: 'NC',
        name: 'North Carolina',
      },
      {
        code: 'ND',
        name: 'North Dakota',
      },
      {
        code: 'MP',
        name: 'Northern Mariana Islands',
      },
      {
        code: 'OH',
        name: 'Ohio',
      },
      {
        code: 'OK',
        name: 'Oklahoma',
      },
      {
        code: 'OR',
        name: 'Oregon',
      },
      {
        code: 'PA',
        name: 'Pennsylvania',
      },
      {
        code: 'PR',
        name: 'Puerto Rico',
      },
      {
        code: 'PW',
        name: 'Palau',
      },
      {
        code: 'RI',
        name: 'Rhode Island',
      },
      {
        code: 'SC',
        name: 'South Carolina',
      },
      {
        code: 'SD',
        name: 'South Dakota',
      },
      {
        code: 'TN',
        name: 'Tennessee',
      },
      {
        code: 'TX',
        name: 'Texas',
      },
      {
        code: 'UT',
        name: 'Utah',
      },
      {
        code: 'VT',
        name: 'Vermont',
      },
      {
        code: 'VA',
        name: 'Virginia',
      },
      {
        code: 'VI',
        name: 'Virgin Islands',
      },
      {
        code: 'WA',
        name: 'Washington',
      },
      {
        code: 'WV',
        name: 'West Virginia',
      },
      {
        code: 'WI',
        name: 'Wisconsin',
      },
      {
        code: 'WY',
        name: 'Wyoming',
      },
    ],
  },
  {
    countryCode: 'CA',
    name: 'Canada',
    regions: [
      {
        code: 'AB',
        name: 'Alberta',
      },
      {
        code: 'BC',
        name: 'British Columbia',
      },
      {
        code: 'MB',
        name: 'Manitoba',
      },
      {
        code: 'NB',
        name: 'New Brunswick',
      },
      {
        code: 'NL',
        name: 'Newfoundland and Labrador',
      },
      {
        code: 'NS',
        name: 'Nova Scotia',
      },
      {
        code: 'NT',
        name: 'Northwest Territories',
      },
      {
        code: 'NU',
        name: 'Nunavut',
      },
      {
        code: 'ON',
        name: 'Ontario',
      },
      {
        code: 'PE',
        name: 'Prince Edward Island',
      },
      {
        code: 'QC',
        name: 'Quebec',
      },
      {
        code: 'SK',
        name: 'Saskatchewan',
      },
      {
        code: 'YT',
        name: 'Yukon',
      },
    ],
  },
];

const countries = countryWithStates.map((c) => ({
  name: c.name,
  value: c.countryCode,
}));

export const countrySelectOptions: AnvilSelectOptionsProps[] = countries.map(
  (country) => ({
    text: country.name,
    value: country.value,
  }),
);

export const getStatesOptionsForCountryCode = (
  countryCode: string,
): AnvilSelectOptionsProps[] => {
  const country = countryWithStates.find((c) => c.countryCode === countryCode);
  const states = country ? country.regions : [];
  return states.map((state) => ({
    text: state.code,
    value: state.code,
  }));
};

export const getCountryFromStateCode = (stateCode: string): string => {
  for (const country of countryWithStates) {
    if (country.regions.some((region) => region.code === stateCode)) {
      return country.countryCode;
    }
  }
  return 'US';
};
